import { render } from "./header.vue?vue&type=template&id=4bb6ba8f"
import script from "./header.vue?vue&type=script&lang=js"
export * from "./header.vue?vue&type=script&lang=js"

import exportComponent from "D:\\Web projects\\GRCDOInventory-front-end\\grcdoinventory\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__